import { generatePageJs, createDataModel, createServiceModel,generateActions } from '../../services/index';
import { convertBodyToHtmlCode } from './GrapesJs/LoadCommands/ExportCode';
import LoadClasses from './GrapesJs/LoadClasses';
import { renderCustomBlocks, renderDataElementsBlocks, renderServiceBlocks } from './renderCreatedBlocks';

// functions to load the components of a page on clicked to local store
function loadUIelements(editor, selectedPage, selectedProject) {
  const projects = JSON.parse(localStorage.getItem('data'));
  const pageToLoad = projects[selectedProject].pages[selectedPage];

  if (pageToLoad !== undefined) {
    localStorage.setItem('gjs-components', JSON.stringify(pageToLoad.components || []));
    localStorage.setItem('gjs-styles', JSON.stringify(pageToLoad.styles || []));
    localStorage.setItem('gjs-assets', JSON.stringify(pageToLoad.assets || []));
  }
  LoadClasses(editor);
  renderDataElementsBlocks(editor,selectedProject);
  renderCustomBlocks(editor,selectedProject);
  renderServiceBlocks(editor,selectedProject)

  editor.load((res) => {
    const keys = ['gjs-components', 'gjs-styles', 'gjs-assets'];
    for (let i = 0, len = keys.length; i < len; i += 1) {
      const v = localStorage.getItem(keys[i]);
      if (v) res[keys[i]] = v;
    }
    return res;
  });
  editor.stopCommand('enable-navigate-page');
  editor.refresh();
}

// function to save the components to the storage pages
function saveUIelements(editor, selectedPage, selectedProject) {
  if (selectedProject > -1 && selectedPage > -1) {
    const projects = JSON.parse(localStorage.getItem('data'));

    projects[selectedProject].pages[selectedPage].components = JSON.parse(
      localStorage.getItem('gjs-components')
    );
    projects[selectedProject].pages[selectedPage].styles = JSON.parse(
      localStorage.getItem('gjs-styles')
    );
    projects[selectedProject].pages[selectedPage].assets = JSON.parse(
      localStorage.getItem('gjs-assets')
    );
    projects[selectedProject].pages[selectedPage].data = createDataModel(
      window.document.getElementById('editor1').getElementsByTagName('iframe').item(0).contentWindow
        .document,
      projects[selectedProject].annotations[0]
    );
    projects[selectedProject].pages[selectedPage].services = createServiceModel(
      window.document.getElementById('editor1').getElementsByTagName('iframe').item(0).contentWindow
        .document
    );

    projects[selectedProject].pages[selectedPage].actions = generateActions(
      window.document.getElementById('editor1').getElementsByTagName('iframe').item(0).contentWindow
      .document
    );
    
    const pageName = projects[selectedProject].pages[selectedPage].name;

    projects[selectedProject].pages[selectedPage].html = convertBodyToHtmlCode(
      editor.getHtml(),
      pageName
    );

    projects[selectedProject].pages[selectedPage].css = editor.getCss();

    const pageJavascript = projects[selectedProject].pages[selectedPage].javascript;

    if (pageJavascript === undefined) {
      projects[selectedProject].pages[selectedPage].javascript = {
        functions: [],
        file: '',
        imports: [],
        changeJavascript: false,
      };
    } else if (pageJavascript.imports === undefined) {
      projects[selectedProject].pages[selectedPage].javascript = {
        functions: [],
        file: '',
        imports: [],
        changeJavascript: false,
      };
    } else if (pageJavascript.changeJavascript === undefined) {
      projects[selectedProject].pages[selectedPage].javascript = {
        functions: [],
        file: '',
        imports: [],
        changeJavascript: false,
      };
    } else {
      projects[selectedProject].pages[selectedPage].javascript.file = generatePageJs(
        pageJavascript.functions,
        projects[selectedProject].annotations,
        window.document.getElementById('editor1').getElementsByTagName('iframe').item(0)
          .contentWindow.document,
        pageJavascript.customFunctions || [],
        projects[selectedProject].services || []
      );
    }

    localStorage.setItem('data', JSON.stringify(projects));
  }
}

// function to clear the editor
function clearUIelements(editor) {
  editor.Components.clear();
  localStorage.removeItem('gjs-styles');
  localStorage.removeItem('gjs-assets');
  localStorage.removeItem('gjs-html');
  localStorage.removeItem('gjs-css');
  localStorage.removeItem('gjs-components');
}

export { loadUIelements, saveUIelements, clearUIelements };
